import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AIDocsProposalsChart() {
	const query = api.analytics.aiDocsProposalsChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="AI Docs Proposals"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
